module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Styles/product.create.scss
// module id = ./src/app/Styles/product.create.scss
// module chunks = main